import $ from 'jquery';
import SectionsList from './sections-list';

class Sections {
    constructor($selector, $contentsList) {
        this.setContent($selector);
        this.$contentslist = $contentsList;
    }

    getContent() {
        return this.$content;
    }

    setContent($content) {
        this.$content = $content;

        this.SectionsList = new SectionsList($content, $('.js-sub-contents-list'), this.$contentslist);
        this.SectionsList.resetHeadingPositions();
    }
}

export default Sections;
